module.exports = __webpack_public_path__ + "static/img/topbg.a54356a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/zyy/topbg.png
// module id = Q6hh
// module chunks = 9